module.exports = __webpack_public_path__ + "img/logo-my-acuvue.1be0415.png?v=1762502055057";